import { useTranslation } from 'react-i18next';
import { FaIdCard, FaListUl, FaUser } from 'react-icons/fa';

import { useNavigate, useShowViewResponse } from 'hooks';
import { Consultation, MenuOption } from 'types';

export const useDetailsMenuOptions = (
  consultation: Consultation | undefined
): MenuOption[] => {
  const { t } = useTranslation('details_header');

  const { navigateToDashboard, navigateToSummary, navigateToResponse } = useNavigate();
  const showViewResponse = useShowViewResponse(consultation);

  const consultationSummary: MenuOption = {
    label: t('consultation_summary', 'Consultation summary'),
    onClick: (consultationId) => consultationId && navigateToSummary(consultationId),
    icon: FaIdCard,
  };

  const respond: MenuOption = {
    label: t('respond', 'Respond'),
    onClick: (consultationId) => consultationId && navigateToResponse(consultationId),
    icon: FaUser,
  };

  const viewResponse: MenuOption = {
    label: t('view_response', 'View response'),
    onClick: (consultationId) => consultationId && navigateToResponse(consultationId),
    icon: FaUser,
  };

  const dashboard: MenuOption = {
    label: t('dashboard', 'Dashboard'),
    onClick: () => navigateToDashboard(),
    icon: FaListUl,
  };

  return consultation?.isArchived
    ? showViewResponse
      ? [consultationSummary, viewResponse, dashboard]
      : [consultationSummary, dashboard]
    : [consultationSummary, respond, dashboard];
};
